import { Model, ModelUpdateRequest } from '@bimdata/definitions/dto';
import { ApiError, CanceledError } from '@bimdata/client';

import store from '@/state/store';

import projectSlice from '@/state/project.slice';
import * as api from '@/api/model';
import { handleError } from '../common';
import { runBulk } from '../utils';

export const remove = async (pid: string, modelIds: number[]) => {
  try {
    const results = await runBulk<number, number>(
      modelIds,
      (mid) => api.remove(pid, mid).then(() => mid),
      (e) => handleError(e)
    );
    onModelsRemove(pid, results);
  } catch (error) {
    handleError(error);
  }
};

export const onModelsRemove = (pid: string, modelIds: number[]) => {
  store.dispatch(projectSlice.actions.removeModels({
    code: pid,
    modelIds
  }));
  store.dispatch(projectSlice.actions.update({ code: pid }));
}

export const download = async (
  pid: string,
  modelId: number,
  controller: AbortController,
  onProgress?: (progress: number, loaded: number, total?: number) => void
): Promise<File | undefined> => {
  try {
    return await api.download(
      pid,
      modelId,
      onProgress,
      controller.signal
    );
  } catch (error) {
    if (error instanceof CanceledError) {
      return;
    }
    handleError(error);
  }
}

export const edit = async (pid: string, modelId: number, data: ModelUpdateRequest) => {
  if (!data.name && data.section === undefined) {
    return;
  }
  try {
    const model = await api.edit(pid, modelId, data);
    onModelsReplace(pid, [ model ]);
  } catch (error) {
    handleError(error);
  }
}

export const bulkSetSection = async (pid: string, modelIds: number[], section: string | null) => {
  try {
    const results = await runBulk<number, Model>(
      modelIds,
      (mid) => api.edit(pid, mid, { section }),
      (e) => handleError(e)
    );
    onModelsReplace(pid, results);
  } catch (error) {
    handleError(error);
  }
}

export const onModelsReplace = (pid: string, models: Model[]) => {
  store.dispatch(projectSlice.actions.addModels({
    code: pid,
    models,
  }));
  store.dispatch(projectSlice.actions.update({ code: pid }));
}

export const modelUploaded = (pid: string) => {
  store.dispatch(projectSlice.actions.update({ code: pid }));
}

export const cancelUpload = async (pid: string, uploadId: string) => {
  try {
    await api.cancelUpload(pid, uploadId);
  } catch (error) {
    handleError(error);
  }
}

export const reprocess = async (pid: string, ids: number[]) => {
  try {
    const result = await api.reprocess(pid, ids);
    if (result !== true) {
      for (const e of Object.values(result)) {
        handleError(
          new ApiError(500, e.message)
        );
      }
    }
  } catch (error) {
    handleError(error);
  }
}
